import { uploadOne } from "../../../hooks/useS3Upload";

export async function fetchBlobFromUrl(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Falha ao preparar arquivo de áudio para envio.");
  }
  return response.blob();
}

export async function uploadTeamFile(file) {
  return uploadOne(file, { prefix: "chat" });
}

export function buildPayloadFromUploadedFile(file, uploadedUrl, caption = "") {
  const content = String(caption || "").trim() || file?.name || " ";
  const type = String(file?.type || "");
  if (type.startsWith("image/")) {
    return { content, messageType: "image", imageUrl: uploadedUrl };
  }
  if (type.startsWith("video/")) {
    return { content, messageType: "video", videoUrl: uploadedUrl };
  }
  if (type.startsWith("audio/")) {
    return { content, messageType: "audio", audioUrl: uploadedUrl };
  }
  return {
    content,
    messageType: "file",
    fileUrl: uploadedUrl,
    fileName: file?.name || "arquivo",
  };
}

export async function buildPayloadFromAudioUrl(audioURL, caption = "") {
  const audioBlob = await fetchBlobFromUrl(audioURL);
  const mimeType =
    audioBlob.type && audioBlob.type !== "audio/mp3" ? audioBlob.type : "audio/mpeg";
  const audioFile = new File([audioBlob], `audio-${Date.now()}.mp3`, { type: mimeType });
  const uploaded = await uploadTeamFile(audioFile);
  return {
    content: String(caption || "").trim() || " ",
    messageType: "audio",
    audioUrl: uploaded.url,
  };
}
